import { css } from "../../../styled-system/css";
import { HStack, VStack } from "../../../styled-system/jsx";
import { styled } from "../../../styled-system/jsx";
import { IoIosSend } from "react-icons/io";
import { MdOutlineCloudUpload } from "react-icons/md";
import Loading from "./Loading";
import { useTranslation } from "react-i18next";

const Button = styled("button", {
  base: {
    backgroundColor: "fuchsia",
    color: "white",
    border: "none",
    borderRadius: "5px",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
  },
});

const DEFAULT_USER_MESSAGE_KEYS = /** @type {const} */ ([
  "What was my conversion rate last month?",
  "List the top 5 selling keywords in the last 2 months?",
  "Which day last month got highest sales?",
]);

const UserMessage = ({ text }) => {
  return (
    <VStack justifyContent={"flex-end"} width="100%" alignItems={"flex-end"}>
      <div
        className={css({
          fontSize: "14px",
          backgroundColor: "#eee",
          color: "black",
          padding: "8px",
          borderRadius: "5px",
          marginBottom: "10px",
          maxWidth: "80%",
        })}
      >
        {text}
      </div>
    </VStack>
  );
};

const ChatContent = ({
  currentConversation,
  messages,
  sendMessageMutation,
  pendingMessage,
  message,
  setMessage,
  handleSendMessage,
  dataFile,
  handleUploadFileMessage,
  BotMessage,
}) => {
  const { t } = useTranslation(["chat"]);
  const defaultUserMessages = DEFAULT_USER_MESSAGE_KEYS.map((key) => t(($) => $.chat.starterPrompts[key]));
  return (
    <>
      <VStack flexGrow={1} width="100%" height="100%" padding="10px" overflowY="auto" flexDirection="column-reverse">
        {currentConversation === null && (
          <>
            <div
              className={css({
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              })}
            >
              {defaultUserMessages.map((msg, index) => (
                <button
                  key={index}
                  className={css({
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid",
                    borderColor: "fuchsia",
                    borderRadius: "5px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    fontSize: "14px",
                    marginBottom: "0",
                  })}
                  onClick={() => {
                    setMessage(msg);
                    handleSendMessage();
                  }}
                >
                  {msg}
                </button>
              ))}
            </div>
            <div
              className={css({
                fontSize: "16px",
                fontWeight: "bold",
                color: "#666",
                textAlign: "center",
                marginTop: "20px",
                marginBottom: "20px",
                width: "100%",
              })}
            >
              {t(($) => $.chat["Hello! How can I assist you today?"])}
            </div>
          </>
        )}
        {sendMessageMutation.isPending && <Loading />}
        {pendingMessage && <UserMessage text={pendingMessage} />}
        {messages.map((msg, index) => (
          <div key={index} className={css({ width: "100%" })}>
            {msg.role === "user" && <UserMessage text={msg.content} />}
            {msg.role === "assistant" && (
              <BotMessage message={msg} text={msg.content || `*${msg.notes || t(($) => $.chat["Thinking"])}...*`} />
            )}
          </div>
        ))}
      </VStack>

      <VStack width="full" padding="0px 10px 10px 10px">
        <HStack width="full" justifyContent="flex-end">
          {dataFile && (
            <Button
              className={css({
                marginBottom: "10px",
              })}
              onClick={() => {
                handleUploadFileMessage();
              }}
            >
              <MdOutlineCloudUpload /> {t(($) => $.chat["Share Table"])}
            </Button>
          )}
        </HStack>
        <HStack border="1px solid #ddd" width="100%" padding="5px" borderRadius="5px">
          <textarea
            placeholder={t(($) => $.chat["Type your message..."])}
            className={css({
              fontSize: "14px",
              border: "none",
              outline: "none",
              padding: "5px",
              width: "100%",
              height: "100%",
              resize: "none",
            })}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
            value={message}
            rows={3}
          />
          <VStack height="100%" justifyContent="flex-end">
            <button
              className={css({
                backgroundColor: "fuchsia",
                color: "white",
                border: "none",
                borderRadius: "50%",
                fontSize: "20px",
                lineHeight: "26px",
                padding: "0",
                width: "26px",
                height: "26px",
                cursor: "pointer",
              })}
              onClick={() => {
                handleSendMessage();
              }}
            >
              <IoIosSend />
            </button>
          </VStack>
        </HStack>
      </VStack>
    </>
  );
};

export default ChatContent;
